import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const ChateauformSection = ({ apiUrl }) => {
  const [meta, setMeta] = useState(null);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const fileRef = useRef(null);

  const fetchData = () => {
    axios
      .get(`${apiUrl}/chateauform/addresses`)
      .then((res) => {
        setEntries(res.data?.entries || []);
        setMeta(res.data?.meta || null);
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const name = file.name.toLowerCase();
    if (!name.endsWith(".docx") && !name.endsWith(".pdf")) {
      toast.error("Format non supporté. Importez un fichier .docx ou .pdf");
      if (fileRef.current) fileRef.current.value = "";
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await axios.post(`${apiUrl}/chateauform/addresses/import`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(`${res.data.count} adresse(s) Chateauform importée(s)`);
      fetchData();
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Erreur lors de l'import");
    } finally {
      setLoading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="space-y-3">
      <p className="text-xs text-slate-500">
        Importez le fichier «&nbsp;Adresses Chateauform&nbsp;» (.docx ou .pdf). Les lieux et leurs adresses
        sont extraits automatiquement et utilisés pour renseigner le champ «&nbsp;Lieu événement&nbsp;»
        lors de l{"'"}analyse des emails Chateauform.
      </p>
      <input
        ref={fileRef}
        type="file"
        accept=".docx,.pdf"
        onChange={handleFile}
        className="hidden"
        data-testid="chateauform-file-input"
      />
      <Button
        variant="outline"
        size="sm"
        className="w-full h-8 text-xs"
        disabled={loading}
        onClick={() => fileRef.current?.click()}
        data-testid="chateauform-import-btn"
      >
        {loading ? (
          <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" />
        ) : (
          <Upload className="w-3.5 h-3.5 mr-1.5" />
        )}
        {loading ? "Import en cours..." : "Importer le fichier"}
      </Button>

      {meta?.count > 0 && (
        <div className="text-[11px] text-slate-500" data-testid="chateauform-meta">
          {meta.count} lieu(x) importé(s) — {meta.filename}
        </div>
      )}

      {entries.length > 0 && (
        <div className="max-h-48 overflow-auto border rounded-md divide-y" data-testid="chateauform-list">
          {entries.map((e, i) => (
            <div key={i} className="px-2 py-1.5 text-[11px]">
              <div className="font-medium text-slate-700">{e.venue}</div>
              <div className="text-slate-400">{e.address}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChateauformSection;
